import './info.scss';

const Info = () => {
    return (
      <div className="info">
        <div className="container">
         <h2>Список кредиторов</h2>
            <ul>
                <li>
                    ООО МФК «ВЗАИМНО», ОГРН 1187746654006, ИНН 7708333218, 
                    адрес: 101000, г. Москва, ул. Мясницкая, д.35, стр.2, помещение 1, эт. 6, комната 14
                </li>
                <li>
                    ООО МФК «Экофинанс», ОГРН 1157746230730, ИНН 7715450868, 
                    адрес: 127051, г. Москва, ул. Садовая-Самотёчная, д. 24/27, 4 этаж
                </li>
                <li>
                    ООО МФК «Турбозайм», ОГРН 137746702367, ИНН 7702820127, 
                    адрес: 123290, г. Москва, тупик Магистральный 1-й, дом 11, стр. 10
                </li>
                <li>
                    ООО МФК «ЭкспрессДеньги», ОГРН 1101215004593, ИНН 1215150103, 
                    КПП 121501001, адрес: 424038, Республика Марий Эл, г. Йошкар-Ола, б-р Чавайна, д. 12, корп. А
                </li>
            </ul>
            
            <h2>Условия займов</h2>
            <p>Займы предоставляются на сумму от 1000 до 100 000 рублей.</p>
            <h2>Требования к заемщику и Условия получения:</h2>

                <p>Возраст от 18 до 100 лет;</p>
                <p>Любая кредитная история.</p>

            <p>
                Минимальная процентная ставка 0% годовых. Максимальная годовая процентная ставка может составлять (APR): 292%. 
                Срок кредита от 70 дней до 365 дней.
            </p>
            <p>
                Необходимо понимать, что при несвоевременном погашении займа будут назначены штрафные санкции со стороны кредитодателя, 
                размер которых составляет около 0,1% от суммы кредита за каждый день неуплаты, в то же время данный штраф не может превышать 
                10% от общей суммы займа.
            </p>
            <p>
                Пример расчета по займу на сумму 10 000 рублей сроком на 10 недель, т. е. на 70 дней, по ставке 0,75% в день - 
                сумма процентов за весь период составит 5 250 рублей. Общая выплата будет равна 15 250 рублей. Дополнительные комиссии отсутствуют.
            </p>
            <h2>ПСК (полная стоимость кредита):</h2>
            <p>
                Максимальная процентная в процентах составляет 292% годовых. Максимальная годовая процентная ставка, включающая ссудный процент, 
                а также все остальные комиссии и расходы за год, или аналогичная ставка.
            </p>
            <h2>Контакты</h2>
            <p><strong>Email:</strong> info@zaym-online.org</p>
            <p><strong>Компания:</strong> Appstatic FZCO</p>
            <p>
                <strong>Адрес:</strong> FZA Business Park, DDP, Premises No 23247 - 001, Dubai Silicon Oasis, Dubai, UAE
            </p>
            <p><strong>Телефон:</strong> +971-502-49-51-57</p>
            <p><strong>Номер лицензии:</strong> 23247</p>
        </div>
        </div>
    )
}

export default Info;